import React, { useState, useEffect, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { AppContext } from '../../application/provider';

/**
 * Modal para CREAR una nueva solicitud de reclutamiento.
 * - tipo_solicitud: 1 = Proceso de Reclutamiento, 2 = Invitación Directa
 * - Si es tipo 2, se habilitan dni/nombre/apellido del candidato
 */
const ModalPersonalReclutamiento = ({ isOpen, onSave, onClose, onModalClosed }) => {
    const [state] = useContext(AppContext);

    const getInitialState = () => ({
        tipo_solicitud: '1',
        solicitud: '',
        dni: '',
        nombre: '',
        apellido: '',
    });

    const [formData, setFormData] = useState(getInitialState());
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setFormData(getInitialState());
        }
    }, [isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        if (!formData.solicitud.trim()) {
            alert('Por favor, ingrese el detalle de la solicitud.');
            return;
        }
        if (formData.tipo_solicitud === '2') {
            if (!formData.dni.trim() || !formData.nombre.trim() || !formData.apellido.trim()) {
                alert('Para invitación directa debe ingresar DNI, Nombre y Apellido del candidato.');
                return;
            }
            if (formData.dni.length !== 8) {
                alert('El DNI debe tener 8 dígitos.');
                return;
            }
        }
        setSaving(true);
        try {
            await onSave({
                tipo_solicitud: parseInt(formData.tipo_solicitud),
                solicitud: formData.solicitud.trim(),
                dni: formData.tipo_solicitud === '2' ? formData.dni.trim() : undefined,
                nombre: formData.tipo_solicitud === '2' ? formData.nombre.trim() : undefined,
                apellido: formData.tipo_solicitud === '2' ? formData.apellido.trim() : undefined,
            });
            onClose(true);
        } catch (error) {
            console.error('Error al guardar:', error);
        } finally {
            setSaving(false);
        }
    };

    const esInvitacion = formData.tipo_solicitud === '2';

    return (
        <Modal isOpen={isOpen} onClosed={onModalClosed} className="custom-modal" backdrop="static" size="lg">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>NUEVA SOLICITUD DE RECLUTAMIENTO</h1>
                    <Button className="close-btn" onClick={() => onClose()}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={(e) => e.preventDefault()}>

                        <FormGroup>
                            <Label>Tipo de Solicitud: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="select"
                                name="tipo_solicitud"
                                value={formData.tipo_solicitud}
                                onChange={handleChange}
                                style={{ maxHeight: 'unset', borderRadius: '6px' }}
                            >
                                <option value="1">PROCESO DE RECLUTAMIENTO</option>
                                <option value="2">INVITACIÓN DIRECTA</option>
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label>Detalle de la Solicitud: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="textarea"
                                name="solicitud"
                                value={formData.solicitud}
                                onChange={handleChange}
                                placeholder="Ingrese aqui el requerimiento"
                                rows={4}
                                maxLength={500}
                                style={{ maxHeight: '120px', borderRadius: '8px' }}
                            />
                            <span className="text-muted" style={{ fontSize: '11px', float: 'right' }}>
                                {(formData.solicitud?.length || 0)} / 500
                            </span>
                            <div style={{ clear: 'both' }}></div>
                        </FormGroup>

                        {esInvitacion && (
                            <>
                                <div style={{
                                    background: 'linear-gradient(135deg, #e8f4fd, #dbeeff)',
                                    border: '1px solid #90caf9',
                                    borderRadius: '8px',
                                    padding: '12px 16px',
                                    marginBottom: '12px',
                                    fontSize: '11px',
                                    color: '#1565c0',
                                    fontWeight: 600
                                }}>
                                    Invitación Directa: Complete los datos del candidato propuesto.
                                </div>

                                <FormGroup>
                                    <Label>DNI del Candidato: <span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        className="form-control"
                                        type="text"
                                        name="dni"
                                        value={formData.dni}
                                        onChange={handleChange}
                                        placeholder="Ingrese el numero de DNI"
                                        maxLength={8}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label>Nombre del Candidato: <span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        className="form-control"
                                        type="text"
                                        name="nombre"
                                        value={formData.nombre}
                                        onChange={handleChange}
                                        placeholder="Nombre(s)"
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label>Apellido del Candidato: <span style={{ color: 'red' }}>*</span></Label>
                                    <Input
                                        className="form-control"
                                        type="text"
                                        name="apellido"
                                        value={formData.apellido}
                                        onChange={handleChange}
                                        placeholder="Apellido(s)"
                                    />
                                </FormGroup>
                            </>
                        )}

                        <FormGroup>
                            <div className="button-container">
                                <Button
                                    className="button-custom"
                                    disabled={saving}
                                    onClick={async () => {
                                        if (window.confirm('¿Está seguro de registrar esta solicitud?')) {
                                            await handleSubmit();
                                        }
                                    }}
                                >
                                    {saving ? 'REGISTRANDO...' : 'REGISTRAR SOLICITUD'}
                                </Button>
                            </div>
                        </FormGroup>

                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalPersonalReclutamiento;